// 'use client';

import React, { Fragment, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { Dialog, Transition } from '@headlessui/react';

import { mergeClasses } from '@utils';

export default function NavigationDrawer({
  children,
  menuRoute,
  menuNavigation,
  hasTinyBanner,
  isOpen,
  onClose,
  afterLeave
}) {
  const menuRef = useRef(null);

  useEffect(() => {
    if (menuRef.current) {
      menuRef.current.scrollTo({
        top: 0
      });
    }
  }, [menuRoute, menuRef]);

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog
        className="relative z-[6000]" // Because of Kindly.
        onClose={() => onClose()}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" />
        </Transition.Child>
        <Dialog.Panel
          className={mergeClasses(
            'fixed inset-0 max-h-screen lg:inset-auto lg:inset-y-0',
            {
              'lg:pt-10': hasTinyBanner
            }
          )}
        >
          {menuNavigation}
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-200"
            enterFrom="transform-gpu translate-x-8 lg:-translate-x-8 opacity-0"
            enterTo="transform-gpu translate-x-0 opacity-100"
            leave="ease-in-out duration-200"
            leaveFrom="transform-gpu translate-x-0 opacity-100"
            leaveTo="transform-gpu translate-x-8 lg:-translate-x-8 opacity-0"
            afterLeave={() => afterLeave()}
          >
            <div
              ref={menuRef}
              className={mergeClasses(
                'relative h-full max-h-screen overflow-x-hidden overflow-y-scroll bg-white/90 backdrop-blur-sm lg:max-h-[calc(100vh-4rem)]',
                {
                  'lg:max-h-[calc(100vh-4rem-40px)]': hasTinyBanner
                }
              )}
            >
              {children}
            </div>
          </Transition.Child>
        </Dialog.Panel>
      </Dialog>
    </Transition>
  );
}

NavigationDrawer.propTypes = {
  children: PropTypes.node,
  menuRoute: PropTypes.arrayOf(PropTypes.number).isRequired,
  menuNavigation: PropTypes.node,
  hasTinyBanner: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  afterLeave: PropTypes.func
};

NavigationDrawer.defaultProps = {
  children: undefined,
  menuNavigation: null,
  afterLeave: () => {}
};
